import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa en estética?',
  a: 'No. El programa está diseñado desde cero. Empezamos con los fundamentos de la piel y anatomía antes de pasar a las técnicas avanzadas.'
}, {
  q: '¿Cuánto tiempo tengo acceso al curso?',
  a: 'El acceso es de por vida. Puedes ver las clases a tu propio ritmo, pausar, retroceder y volver a verlas cuantas veces necesites. Además, tendrás acceso a todas las futuras actualizaciones sin costo extra.'
}, {
  q: '¿Recibo un certificado al finalizar?',
  a: 'Sí. Al completar todos los módulos y aprobar la evaluación final, recibirás un certificado profesional descargable que avala tus conocimientos.'
}, {
  q: '¿Cómo puedo pagar?',
  a: 'Aceptamos todas las tarjetas de crédito/débito, PayPal y métodos de pago locales dependiendo de tu país. El pago es 100% seguro.'
}, {
  q: '¿Funciona si vivo fuera de España?',
  a: '¡Totalmente! El curso es 100% online y tenemos alumnas de toda Latinoamérica, Estados Unidos y Europa. Los principios anatómicos y técnicos son universales.'
}, {
  q: '¿Y si el curso no me gusta?',
  a: 'Tienes una garantía incondicional de 7 días. Si entras y sientes que el contenido no cumple tus expectativas, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-75">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-76">
        <div className="text-center mb-16" data-id="element-77">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-text-main mb-4" data-id="element-78">
            Preguntas <span className="text-fuchsia italic" data-id="element-79">Frecuentes</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-80">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-2xl transition-colors duration-300 ${openIndex === index ? 'border-fuchsia bg-pink-light/10' : 'border-pink-medium bg-white'}`} data-id="element-81">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-82">
                <span className="font-bold text-text-main pr-4" data-id="element-83">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-fuchsia transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-84" />
              </button>

              <AnimatePresence data-id="element-85">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-86">
                    <div className="p-6 pt-0 text-text-muted leading-relaxed" data-id="element-87">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};